"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLDragContext = exports.OLDragProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Collection_1 = __importDefault(require("ol/Collection"));
const Translate_1 = __importDefault(require("ol/interaction/Translate"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLDragProvider({ children }) {
    const map = useOLMap_1.useOLMap();
    const draggableFeatures = react_1.useMemo(() => new Collection_1.default(), []);
    const dragInteraction = react_1.useMemo(() => {
        return new Translate_1.default({ features: draggableFeatures });
    }, [draggableFeatures]);
    react_1.useEffect(() => {
        map.addInteraction(dragInteraction);
        return () => {
            map.removeInteraction(dragInteraction);
        };
    }, [map, dragInteraction]);
    react_1.useEffect(() => {
        const onTranslateStart = (event) => {
            event.features.forEach(feature => feature.dispatchEvent('dragstart'));
        };
        dragInteraction.on('translatestart', onTranslateStart);
        return () => {
            dragInteraction.un('translatestart', onTranslateStart);
        };
    }, [dragInteraction]);
    react_1.useEffect(() => {
        const onTranslating = (event) => {
            event.features.forEach(feature => feature.dispatchEvent('dragging'));
        };
        dragInteraction.on('translating', onTranslating);
        return () => {
            dragInteraction.un('translating', onTranslating);
        };
    }, [dragInteraction]);
    react_1.useEffect(() => {
        const onTranslateEnd = (event) => {
            event.features.forEach(feature => feature.dispatchEvent('dragend'));
        };
        dragInteraction.on('translateend', onTranslateEnd);
        return () => {
            dragInteraction.un('translateend', onTranslateEnd);
        };
    }, [dragInteraction]);
    const value = react_1.useMemo(() => ({ draggableFeatures }), [draggableFeatures]);
    return jsx_runtime_1.jsx(exports.OLDragContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.OLDragProvider = OLDragProvider;
exports.OLDragContext = react_1.createContext({
    draggableFeatures: new Collection_1.default(),
});
//# sourceMappingURL=OLDragProvider.js.map